<div>
  <div class="flex items-center justify-center h-[70px]">
    <h4 class="xl:text-xl lg:text-lg text-primary text-lg font-medium font-sans font-medium flex items-center gap-1.5">
      Add Child / Linked WO
      @if (WOCode) {
        <span class="font-sans font-medium text-primary bg-[--primary-light-color] rounded-[20px] px-[10px] py-[2px] leading-normal text-[12px]">
          {{ WOCode }}
        </span>
      }
    </h4>
    <button (click)="addNewRows()" mat-fab class="primary-status !bg-[var(--color-button-quiet)] !text-[var(--color-text)] !border-0 !w-8 !h-8 !rounded-full !absolute right-[1rem]">
      <mat-icon svgIcon="c:plus"></mat-icon>
    </button>
  </div>

  <mat-dialog-content class="!pt-0">
    <form [formGroup]="childWorkOrderForm" class="flex flex-col space-y-4">
      <div class="flex flex-col gap-5">

        <!-- Work Order Type -->
        <div class="rounded-lg">
          <mat-form-field class="w-full" subscriptSizing="dynamic">
            <mat-label>Work Order Type</mat-label>
            <mat-select formControlName="workOrderType">
              @for (type of workOrderTypeList; track type) {
                <mat-option [value]="type.id">
                  {{type.name}}
                </mat-option>
              }
            </mat-select>
            @if (workOrderTypesLoaded && workOrderTypeList.length === 0) {
              <mat-hint>No child work order types are set up for this work order type.</mat-hint>
            }
            @if (childWorkOrderForm.get('workOrderType').touched && childWorkOrderForm.get('workOrderType').hasError('required')) {
              <mat-error
                >
                Work Order Type is required.
              </mat-error>
            }
          </mat-form-field>
        </div>

        <!-- Number of Child Work Orders -->
        <div class="rounded-lg !h-fit">
          <mat-form-field appearance="outline" class="w-full" subscriptSizing="dynamic">
            <mat-label>Number of Child Work Orders</mat-label>
            <input matInput type="number" formControlName="numOfChildWorkOrders" min="0" max="25"
              (keyup.enter)="generateChildWoRefInputs()" pattern="[0-9]*"
              (keypress)="$event.charCode >= 48 && $event.charCode <= 57"
              (focusout)="generateChildWoRefInputs()">
              @if (childWorkOrderForm.get('numOfChildWorkOrders').touched && childWorkOrderForm.get('numOfChildWorkOrders').hasError('required')) {
                <mat-error
                  >
                  Number of Child Work Orders is required.
                </mat-error>
              }
              @if (childWorkOrderForm.get('numOfChildWorkOrders').touched && childWorkOrderForm.get('numOfChildWorkOrders').hasError('max')) {
                <mat-error
                  >
                  Maximum number of Child Work Orders allowed is 25.
                </mat-error>
              }
            </mat-form-field>
          </div>

          <!-- Reference Names -->
          <div>
            <div formArrayName="referenceNames" class="flex flex-col gap-5">
              @for (referenceNameControl of referenceNames.controls; track $index; let i = $index) {
                <div
                  class="rounded-lg bg-[#e5e0f26e] p-2 h-fit">
                  <div class="flex items-center space-x-2">
                    <span class="flex items-center justify-center !min-h-[28px] !min-w-[28px] bg-primary rounded-full text-white">{{i + 1}}</span>
                    <mat-form-field class="refField" appearance="outline" subscriptSizing="dynamic">
                      <mat-label>Reference Name</mat-label>
                      <input matInput [formControlName]="i" type="text" (keypress)="$event.key !== ','">
                      <!-- TODO: for create form field fill automatically  -->
                      <!-- <button mat-icon-button matSuffix *ngIf="referenceNameControl.value"
                      (click)="onReferenceNameChange(i)" color="primary">
                      <mat-icon svgIcon="c:sparkles"></mat-icon>
                    </button> -->
                    <!-- <button mat-icon-button matSuffix>
                    <mat-icon svgIcon="c:question-circle"></mat-icon>
                  </button> -->
                </mat-form-field>
                <button mat-icon-button color="warn" (click)="removeReferenceName(i)">
                  <mat-icon svgIcon="c:trash"></mat-icon>
                </button>
              </div>
              @if (referenceNameControl.touched && referenceNameControl.hasError('required')) {
                <mat-error
                  class="text-xs mt-1">
                  Reference Name {{i + 1}} is required.
                </mat-error>
              }
            </div>
          }
        </div>
      </div>
    </div>

  </form>
</mat-dialog-content>
<!-- Submit Button -->
<mat-dialog-actions class="!p-0 flex !justify-center !mb-3 !mt-3">
  <button mat-stroked-button mat-dialog-close color="accent" class="!h-[33px] !border !border-primary !bg-transparent !text-primary">Cancel</button>
  <button mat-flat-button class="text-primary primary-button" (click)="onSave()">Save</button>
</mat-dialog-actions>
</div>